module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-2nd-df83c05fcb96fd7dda9a45320cce8a49.png";